export const defaultOpacity = 0.5;
export const emptyPreset = 'NOFX';
export const autoMinRank = 10000;
export const PlaceableType = {
	TOKEN: foundry.canvas.placeables.Token.embeddedName,
	TILE: foundry.canvas.placeables.Tile.embeddedName,
	TEMPLATE: foundry.canvas.placeables.MeasuredTemplate.embeddedName,
	DRAWING: foundry.canvas.placeables.Drawing.embeddedName,
	REGION: foundry.canvas.placeables.Region.embeddedName,
	NOT_SUPPORTED: null,
};
